"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Caption = _interopRequireDefault(require("./Caption.style"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var Caption = function Caption(_ref) {
  var caption = _ref.caption,
    captionPosition = _ref.captionPosition,
    className = _ref.className,
    mandatory = _ref.mandatory;
  return /*#__PURE__*/_react["default"].createElement(_Caption["default"], {
    className: className,
    captionPosition: captionPosition,
    mandatory: mandatory
  }, caption);
};
Caption.defaultProps = {
  captionPosition: 'bottom',
  className: 'card-caption',
  mandatory: false
};
Caption.propTypes = {
  captionPosition: _propTypes["default"].oneOf(['top', 'bottom', 'bottom-card']),
  /**
   * A text to be displayed at the bottom containing some captions
   * (eg. required fields)
   * */
  caption: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].node]).isRequired,
  /* The html classname */
  className: _propTypes["default"].string,
  mandatory: _propTypes["default"].bool
};
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(Caption);